<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de profissional">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/exame-imagem/jornada/List'

export default {
    components: { List },
}
</script>